import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorFallback from '@/components/ErrorFallback';
import Spinner from '@/components/Spinner';
import env from '@/utils/constants';

export function AppProvider({ children }: { children: React.ReactNode }) {
  const queryClient = new QueryClient();

  return (
    <React.Suspense
      fallback={(
        <div className="grid place-items-center w-screen h-screen">
          <Spinner size="xl" />
        </div>
      )}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {env.VITE_APP_VERSION === 'local' && <ReactQueryDevtools />}
            <Router>{children}</Router>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
}

export default AppProvider;
